import { render } from "./PdfCartaPropostaComponente.vue?vue&type=template&id=a7fd2ac4&scoped=true"
import script from "./PdfCartaPropostaComponente.vue?vue&type=script&lang=js"
export * from "./PdfCartaPropostaComponente.vue?vue&type=script&lang=js"

import "./PdfCartaPropostaComponente.vue?vue&type=style&index=0&id=a7fd2ac4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7fd2ac4"]])

export default __exports__